export enum PlayerData {
  INDEX = '/player-data',
}
